import React from "react";

// Tham khảo logic "đang chơi" từ src/pages/Home-Winaz-Tan-Thu/useLiveStats.ts —
// dao động quanh 1 mức nền theo giờ trong ngày, cập nhật mỗi ONLINE_TICK_MS.
const ONLINE_TICK_MS = 7_000;

const randBetween = (min: number, max: number) =>
  Math.floor(min + Math.random() * (max - min));

const onlineBaseByHour = (hour: number) => {
  if (hour < 6) return 80;
  if (hour < 11) return 105;
  if (hour < 14) return 125;
  if (hour < 18) return 115;
  if (hour < 23) return 145;
  return 110;
};

export const useOnlineCount = () => {
  const [online, setOnline] = React.useState(() =>
    onlineBaseByHour(new Date().getHours()) + randBetween(-8, 8),
  );

  React.useEffect(() => {
    const timer = window.setInterval(() => {
      setOnline((prev) => {
        const base = onlineBaseByHour(new Date().getHours());
        const pullToBase = (base - prev) * 0.1;
        const amplitude = prev * (0.01 + Math.random() * 0.02);
        const noise = (Math.random() < 0.5 ? -1 : 1) * amplitude;
        return Math.max(1, Math.round(prev + pullToBase + noise));
      });
    }, ONLINE_TICK_MS);
    return () => window.clearInterval(timer);
  }, []);

  return online;
};
